import { config } from 'conf/index'
import { useRoutes } from 'react-router-dom'
import AuthRoutes from './AuthRoutes'
import MainRoutes from './MainRoutes'

export default function Routes() {
  const routes = useRoutes([MainRoutes, AuthRoutes], config.basepath)
  return routes
}
